import Service from "./Service";
const baseurl = '/api/formatos-urgencia';

export default {
showSignosVitales (params = {}) {
    return Service.get(`${baseurl}/signos-vitales/show`, {
        params: params
    });
},

storeSignosVitales (data = {}) {
    return Service.post(`${baseurl}/signos-vitales/store`, data);
},

destroySignosVitales (id) {
    return Service.delete(`${baseurl}/signos-vitales/destroy/${id}`);
},

destroyLiquidosTipo (id) {
    return Service.delete(`${baseurl}/liquidos-tipo/destroy/${id}`);
},

showTiposLiquido (params = {}) {
    return Service.get(`${baseurl}/tipos-liquido/show`, {
        params: params
    });
},

storeLiquidosTipo (data = {}) {
    return Service.post(`${baseurl}/tipos-liquido/store`, data);
},

showControlLiquidosByHistoria (idHistoria) {
    return Service.get(`${baseurl}/control-liquidos/show-by-historia/${idHistoria}`);
},

storeControlLiquidos (data) {
    return Service.post(`${baseurl}/control-liquidos/store`, data);
},

generarPdfControlLiquidos (idControl) {
    return `${process.env.VUE_APP_BASE_PATH}${baseurl}/control-liquidos/generar-pdf/${idControl}`;
},

destroyControlLiquidos(id) {
    return Service.delete(`${baseurl}/control-liquidos/destroy/${id}`);
},

}